export default __webpack_public_path__ + "static/react-71f186f9fcd69d23fe85291264933423.png";